export default class CustomIframeController {

    constructor($scope, $injector) {
        this.scope = $scope;
        this.injector = $injector;

        this.userStore = this.injector.get('Users');
        this.stateParams = this.injector.get('$stateParams');
        this.sce = this.injector.get('$sce');

        this.currentIframe = null;
        this.availableIFrames = [];
        this._initWatchers();
    }

    $onInit() {
        this.availableIFrames = _.get(this.userStore.state, 'company.settings.core.custom_iframes', []);
    }

    _initWatchers() {
        this.scope.$watch(() => {
            return this.stateParams.iframeAlias;
        }, () => {
            this._checkCurrentIframe();
        })
    }

    _checkCurrentIframe() {
        _.each(this.availableIFrames, (iframe) => {
            if (
                iframe.alias === this.stateParams.iframeAlias
                && (
                    !this.currentIframe
                    || this.currentIframe.alias !== iframe.alias
                )
            ) {
                this.currentIframe = _.cloneDeep(iframe);
                this.currentIframe.url = this.sce.trustAsResourceUrl(this.currentIframe.iframe_url);

                this._sendTokenToIframe();
            }
        })
    }

    _sendTokenToIframe() {
        this.injector.get('$timeout')(() => {
            angular.element('#custom-customer-iframe')[0].addEventListener("load", function () {
                const dataToSend = JSON.stringify({
                    'type': 'set_token',
                    'content': localStorage.getItem('satellizer_token')
                });
                this.contentWindow.postMessage(dataToSend, '*');
            });
        }, 0);
    }

}

CustomIframeController.$inject = [
    '$scope',
    '$injector'
];



// WEBPACK FOOTER //
// ./src/app/modules/core/controllers/custom-iframe-controller.js